import { restClientV2 } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export interface PayoutRequest {
  id: number
  trainer_id: number
  trainer_name?: string | null
  trainer_phone?: string | null
  amount_requested: number
  balance_at_request: number
  status: 'PENDING' | 'APPROVED' | 'REJECTED'
  trainer_note?: string | null
  requested_at?: string | null
  resolved_at?: string | null
  resolved_by_admin_id?: number | null
  linked_payout_id?: number | null
  admin_remarks?: string | null
  created_at?: string
}

export interface PayoutRequestList {
  total: number
  count_per_page: number
  page: number
  requests: PayoutRequest[]
}

export interface ResolvePayoutRequestPayload {
  request_id: number
  action: 'approve' | 'reject'
  payment_method?: string
  txn_id?: string
  document_path?: string
  remarks?: string
}

export const payoutRequestService = {
  list: (p: { page?: number; limit?: number; status?: string; trainer_id?: number } = {}): Promise<PayoutRequestList> => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.status) params.status = p.status
    if (p.trainer_id) params.trainer_id = p.trainer_id
    return restClientV2.get(`${endpoints.payoutRequests.list}?${q(params)}`).then(r => r.data?.data)
  },
  resolve: (data: ResolvePayoutRequestPayload) =>
    restClientV2.post(endpoints.payoutRequests.resolve, data).then(r => r.data?.data),
  // Per-booking → per-session payout breakdown for one trainer.
  trainerBreakdown: (p: { trainer_id: number; date?: string; page?: number; limit?: number }): Promise<TrainerBreakdown> => {
    const params: Record<string, unknown> = { trainer_id: p.trainer_id, page: p.page ?? 1, limit: p.limit ?? 100 }
    if (p.date) params.date = p.date
    return restClientV2.get(`${endpoints.payoutRequests.trainerBreakdown}?${q(params)}`).then(r => r.data?.data)
  },
  // Settle selected session lines in one payment (amount summed server-side).
  paySessions: (data: PaySessionsPayload) =>
    restClientV2.post(endpoints.payoutRequests.paySessions, data).then(r => r.data?.data),
}

export interface PaySessionsPayload {
  trainer_id: number
  items: { transaction_id: number; amount: number }[]
  payment_method?: string
  txn_id?: string
  remarks?: string
}

export interface PayoutSessionLine {
  transaction_id: number
  amount: number
  paid_amount: number
  remaining: number
  remarks?: string | null
  date: string
  paid: boolean
  payout_id?: number
  paid_at?: string
}
export interface PayoutBookingBreakdown {
  booking_id: number
  package_name: string
  booking_date: string
  payment_method: string
  no_of_sessions: number
  completed_sessions: number
  net_payout: number
  paid_total: number
  unpaid_total: number
  sessions: PayoutSessionLine[]
}
export interface TrainerBreakdown {
  date_filter: string
  total: number
  grand_total: number
  unpaid_total: number
  page: number
  count_per_page: number
  bookings: PayoutBookingBreakdown[]
}
